<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-container>
      <v-row justify="center">
        <v-dialog
          scrollable
          v-model="dialogs.delete"
          persistent
          max-width="400"
        >
          <material-card
            v-if="selectedItem"
            :title="$t('views.portalnews.delete_news')"
            :color="$vuetify.theme.themes.light.error"
            icon="delete"
          >
            <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
            <v-card-actions>
              <v-btn color text @click="dialogs.delete = false">
                {{ $t("globals.cancel") }}
              </v-btn>
              <v-btn color="error" text @click="tryDelete">
                {{ $t("globals.delete") }}
              </v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog
          v-model="dialogs.deactivate"
          scrollable
          persistent
          max-width="400"
        >
          <material-card
            v-if="selectedItem"
            :title="$t('views.portalnews.deactivate_news')"
            :color="$vuetify.theme.themes.light.error"
            icon="toggle_off"
          >
            <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
            <v-card-actions>
              <v-btn
                :disabled="saving"
                text
                @click="dialogs.deactivate = false"
                >{{ $t("globals.cancel") }}</v-btn
              >
              <v-btn
                color="error"
                :loading="saving"
                @click="activate(false)"
                >{{ $t("globals.deactivate") }}</v-btn
              >
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog
          v-model="dialogs.activate"
          scrollable
          persistent
          max-width="400"
        >
          <material-card
            v-if="selectedItem"
            :title="$t('views.portalnews.activate_news')"
            :color="$vuetify.theme.themes.light.success"
            icon="toggle_on"
          >
            <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
            <v-card-actions>
              <v-btn
                :disabled="saving"
                text
                @click="dialogs.activate = false"
                >{{ $t("globals.cancel") }}</v-btn
              >
              <v-btn
                color="success"
                :loading="saving"
                @click="activate(true)"
                >{{ $t("globals.activate") }}</v-btn
              >
            </v-card-actions>
          </material-card>
        </v-dialog>
        <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1200">
          <material-card
            v-if="selectedItem"
            :title="$t(formTitle)"
            :icon="formIcon"
            :color="formColor"
          >
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-container fluid>
                  <v-row>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <no-autocomplete-textfield
                        v-model="selectedItem.Name"
                        :label="$t('globals.name')"
                      ></no-autocomplete-textfield>
                    </v-col>
                    <!-- <v-col xs="12" sm="6" md="4" lg="3">
                      <trans-select
                        :item="selectedItem"
                        propertyName="Type"
                        :items="types"
                        :label="$t('globals.type')"
                        :rules="[$rules.required]"
                      ></trans-select>
                    </v-col> -->
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <no-autocomplete-textfield
                        type="number"
                        :label="$t('globals.priority')"
                        v-model="selectedItem.Order"
                        :rules="[$rules.requiredNum]"
                      />
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <no-autocomplete-textfield
                        type="number"
                        :label="$t('headers.news.seconds')"
                        v-model="selectedItem.Seconds"
                        :rules="[$rules.requiredNum]"
                      />
                    </v-col>
                    <v-col xs="12" sm="6" md="4" lg="3">
                      <v-checkbox
                        v-model="selectedItem.Active"
                        :label="$t('globals.active')"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <template
                      v-if="
                        selectedItem.Type !== undefined &&
                          selectedItem.Type !== null
                      "
                    >
                      <v-col v-if="selectedItem.Type.Id === imageType.Id">
                        <div class="title">Image</div>
                        <div
                          v-for="trans of selectedItem.Translations"
                          v-bind:key="trans.LanguageCode"
                        >
                          <div class="col-md-6 col-xs-12">
                            <div class="row">
                              <h5 style="margin-left:5px">
                                {{ trans.LanguageName }}
                              </h5>
                            </div>
                            <image-picker
                              :image.sync="trans.Image"
                            ></image-picker>
                            <no-autocomplete-textfield
                              v-model="trans.ImageLink"
                              :label="$t('components.themesettings.link')"
                            ></no-autocomplete-textfield>
                          </div>
                        </div>
                      </v-col>
                      <v-col
                        xs="12"
                        v-else-if="selectedItem.Type.Id === textType.Id"
                      >
                        <trans-texteditor
                          v-model="selectedItem"
                          :label="$t('headers.news.text')"
                          field="Html"
                          :dialog="dialogs.edit"
                          :rules="[$rules.required]"
                          class="required"
                        ></trans-texteditor>
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn :disabled="saving" text @click="close()">
                {{ $t("globals.cancel") }}
              </v-btn>
              <v-btn
                :loading="saving"
                :disabled="!validFunc()"
                color="primary"
                @click="save()"
                >{{ $t("globals.save") }}</v-btn
              >
            </v-card-actions>
          </material-card>
        </v-dialog>
      </v-row>
    </v-container>
    <material-card
    :title="$t('components.themesettings.banner')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="view_carousel"
    >
      <v-container>
        <div class="row" v-if="newsSettings != null">
          <div class="col-md-6 col-xs-12">
            <no-autocomplete-textfield
              v-model="newsSettings.Interval"
              type="number"
              :label="$t('headers.downloadcategories.interval')"
            ></no-autocomplete-textfield>
          </div>
          <div style="margin: auto;" class="col-md-6 col-xs-12">
            <v-btn color="primary" text @click="saveSettings">{{
              $t("globals.save")
            }}</v-btn>
          </div>
        </div>
      </v-container>
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :floatActions="floatActions"
        :rowActions="rowActions"
        fileNamePrefix="portal_news"
        :sortBy="'Name'"
        :sortDescending="true"
        identifier="portal_news"
        @error="error=$event"
      ></pbas-data-table>

      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{ $t(message) }}
        <v-btn dark text @click="snackbar = false">{{
          $t("globals.close")
        }}</v-btn>
      </v-snackbar>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import NewsHeaders from "../headers/News";
import ErrorHandler from "../components/ErrorHandler";
import TransTexteditor from "../components/TransTexteditor";
import TransSelect from "../components/TransSelect";
import ImagePicker from "../components/ImagePicker";
import store from "@/store";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import { portalPermission } from "../mixins/portalPermission";

export default {
  components: {
    ErrorHandler,
    TransSelect,
    TransTexteditor,
    ImagePicker,
    NoAutocompleteTextfield
  },
  mixins: [planSetter, portalPermission],
  data() {
    return {
      valid: true,
      selectedItem: null,
      error: null,
      statuses: [],
      types: [],
      dialogs: {
        edit: false,
        activate: false,
        deactivate: false,
      },
      newsSettings: null,
      saving: false,
      provider: undefined,
      isNew: false,
      floatActions: [
        {
          name: "add",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            const languages = store.getters["common/languages"];
            this.isNew = true;
            this.selectedItem = {
              PlanId: this.selectedPlan.Id,
              Translations: [],
              Type: this.textType
            };
            for (var l of languages) {
              this.selectedItem.Translations.push({
                LanguageCode: l.language,
                LanguageName: l.title,
              });
            }
            this.dialogs.edit = true;
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: async (item) => {
            this.selectedItem = this.deepCopy(item);
            this.isNew = false;
            this.dialogs.edit = true;
          },
        },
        {
          name: "deactivate",
          icon: "toggle_off",
          title: "globals.deactivate",
          handler: async (item) => {
            try {
              this.selectedItem = this.deepCopy(item);
              this.dialogs.deactivate = true;
            } catch (error) {
              this.error = error;
            }
          },
          visible: (item) => {
            return item.Active;
          },
        },
        {
          name: "activate",
          icon: "toggle_on",
          title: "globals.activate",
          handler: async (item) => {
            try {
              this.selectedItem = this.deepCopy(item);
              this.dialogs.activate = true;
            } catch (error) {
              this.error = error;
            }
          },
          visible: (item) => {
            return !item.Active;
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: async (item) => {
            try {
              this.selectedItem = this.deepCopy(item);
              this.dialogs.delete = true;
            } catch (error) {
              this.error = error;
            }
          },
        },
      ],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      headers: NewsHeaders,
    };
  },
  computed: {
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    formTitle() {
      return this.isNew
        ? "components.hoursbulktable.create"
        : "globals.edit";
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
    // ...mapGetters("downloadCenter", ["cmsEnums"]),
    imageType() {
      if (this.types.length === 0) return null;
      return this.types.filter((o) => o.Name === "Image")[0];
    },
    textType() {
      if (this.types.length === 0) return null;
      return this.types.filter((o) => o.Name === "Text")[0];
    },
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("downloadCenter", [
      "saveNews",
      "deleteNews",
      "getNewsSettings",
      "saveNewsSettings",
    ]),
    validFunc() {
      if (this.selectedItem===null || this.selectedItem === undefined) return false;
      let valid = this.valid;
      if (!valid) return valid;
      if (this.selectedItem.Type===null || this.selectedItem.Type === undefined) return valid;
      if (this.selectedItem.Type.Id !== this.imageType) return valid;
      for (const trans of this.selectedItem.Translations) {
        valid = trans.Image !== null && trans.Image !== undefined && trans.ImageLink !== null && trans.ImageLink !== undefined
        if (!valid) break;
      }
      return valid;
    },
    async loadPlanData() {
      this.statuses = this.columnsDropDownOptions.Models.Status;
      this.newsSettings = (await this.getNewsSettings(
        this.selectedPlan.Id
      )).value[0];
      this.types = this.columnsDropDownOptions.Models.NewsItemTypes;
      this.provider = new PbasOData(
        this.$axiosHttp,
        this.settings.APIURL +
          "cms/odata/Plans(" +
          this.selectedPlan.Id +
          ")/NewsItems",
        this.headers
      );
    },
    async save() {
      let item = JSON.parse(JSON.stringify(this.selectedItem));
      item.PlanId = this.selectedPlan.Id;
      item.TypeId = item.Type.Id;
      delete item.Type;
      for (var trans of item.Translations) {
        delete trans["LanguageName"];
        if (trans.Image) {
          trans.ImageId = trans.Image.Id;
          delete trans["Image"];
        }
      }
      this.saving = true;
      try {
        await this.saveNews({
          planId: this.selectedPlan.Id,
          news: item,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.close();
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async activate(active) {
      // this.saving = true;
      this.selectedItem.Active = active;
      this.save();
      this.dialogs.deactivate = false;
      this.dialogs.activate = false;
      // try {
      // await this.save();
      // this.$refs.table.getDataAsync();
      // if (this.$refs.form) this.$refs.form.resetValidation();
      // this.color = "success";
      // this.message = "globals.success";
      // this.snackbar = true;
      // this.dialogs.deactivate = false;
      // this.dialogs.activate = false;
      // } catch (error) {
      //   this.error = error;
      // }
      // this.saving = false;
    },
    async tryDelete(item) {
      this.saving = true;
      try {
        await this.deleteNews(this.selectedItem);
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.dialogs.delete = false;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async saveSettings() {
      try {
        await this.saveNewsSettings({
          planId: this.selectedPlan.Id,
          newsSettings: this.newsSettings,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        await this.loadPlanData();
      } catch (error) {
        this.error = error;
      }
    },
    deepCopy(inObject) {
      let outObject, value, key;
      if (typeof inObject !== "object" || inObject === null) {
        return inObject; // Return the value if inObject is not an object
      }
      // Create an array or object to hold the values
      outObject = Array.isArray(inObject) ? [] : {};
      for (key in inObject) {
        value = inObject[key];
        // Recursively (deep) copy for nested objects, including arrays
        outObject[key] = this.deepCopy(value);
      }
      return outObject;
    },
    close() {
      this.selectedItem = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.dialogs.edit = false;
    },
  },
};
</script>
